module.exports = `${require.publicPath}bg.5d9ad7fc.png`;